var lib_core  = require("lib-core");

var ProcessMessageModel        = require("./processMessageModel.js");
var ProcessMessageView         = require("./processMessageView.js");
var ProcessMessageStateMachine = require("./processMessageStateMachine.js");

var ProcessMessageController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

};
lib_core.inherit(ProcessMessageController, lib_core.Controller);
ProcessMessageController.inject = {
};

module.exports = ProcessMessageController;

ProcessMessageController.prototype.createStateMachine = function () {
    return new ProcessMessageStateMachine(this.root, this.getModel());
};

ProcessMessageController.prototype.createModel = function () {
    return new ProcessMessageModel();
};

ProcessMessageController.prototype.createView = function () {
    var holder = this.root.editorHolder;
    if(this.configuration.useParent){
        holder = this.parent().getView().getTemplate().$el;
    }
    return new ProcessMessageView(this.getModel(), holder, holder);
};
